import React from 'react';
import AudioPlayerH5 from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const AudioPlayer = ({ innerRef, ...props }) => {
  return <AudioPlayerH5 ref={innerRef} {...props} />;
};

export default AudioPlayer;
